import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';

export default class AppUi extends Component {
  @tracked activeSection = 'MwButton';
  @tracked selectedTab = 'components';

  uiBookComponents = [
    { cName: 'MwButton', cId: 'ui-book/mw-button', figmaUrl: 'https://www.figma.com/design/IRWiqQ0jR1jVIY7uOu8YSq/%F0%9F%94%97Design-System--NEW-?node-id=50-1159' },
    { cName: 'MwInput', cId: 'ui-book/mw-input', figmaUrl: 'https://www.figma.com/design/IRWiqQ0jR1jVIY7uOu8YSq/%F0%9F%94%97Design-System--NEW-?node-id=206-10352' },
    { cName: 'MwCheckbox', cId: 'ui-book/mw-checkbox', figmaUrl: 'https://www.figma.com/design/IRWiqQ0jR1jVIY7uOu8YSq/%F0%9F%94%97Design-System--NEW-?node-id=1145-12288' },
    { cName: 'MwRadio', cId: 'ui-book/mw-radio', figmaUrl: 'https://www.figma.com/design/IRWiqQ0jR1jVIY7uOu8YSq/%F0%9F%94%97Design-System--NEW-?node-id=1152-1654' },
    { cName: 'MwSwitch', cId: 'ui-book/mw-switch', figmaUrl: 'https://www.figma.com/design/IRWiqQ0jR1jVIY7uOu8YSq/%F0%9F%94%97Design-System--NEW-?node-id=1145-14151' },
    { cName: 'MwSelectMenu', cId: 'ui-book/mw-select', figmaUrl: 'https://www.figma.com/design/IRWiqQ0jR1jVIY7uOu8YSq/%F0%9F%94%97Design-System--NEW-?node-id=206-8965' },
    { cName: 'MwTextarea', cId: 'ui-book/mw-textarea', figmaUrl: '' },
    { cName: 'MwAvatar', cId: 'ui-book/mw-avatar', figmaUrl: 'https://www.figma.com/design/IRWiqQ0jR1jVIY7uOu8YSq/%F0%9F%94%97Design-System--NEW-?node-id=435-2687' },
    { cName: 'MwNavSimple', cId: 'ui-book/mw-nav-simple', figmaUrl: 'https://www.figma.com/design/IRWiqQ0jR1jVIY7uOu8YSq/%F0%9F%94%97Design-System--NEW-?node-id=419-8884' },
    { cName: 'MwLogo', cId: 'ui-book/mw-logo', figmaUrl: 'https://www.figma.com/design/IRWiqQ0jR1jVIY7uOu8YSq/%F0%9F%94%97Design-System--NEW-?node-id=1557-1924' },
    { cName: 'MwBadge', cId: 'ui-book/mw-badge', figmaUrl: '' },
    { cName: 'MwToaster', cId: 'ui-book/mw-toaster', figmaUrl: 'https://www.figma.com/design/IRWiqQ0jR1jVIY7uOu8YSq/%F0%9F%94%97Design-System--NEW-?node-id=1190-5245' },
  ];

  uiBookGuidelines = [
    { cName: 'Dialogs', cId: 'ui-book/dialogs', figmaUrl: '' },
    { cName: 'Colors', cId: 'ui-book/colors', figmaUrl: 'https://www.figma.com/design/IRWiqQ0jR1jVIY7uOu8YSq/%F0%9F%94%97Design-System--NEW-?node-id=2-45' },
    { cName: 'Icons', cId: 'ui-book/icons', figmaUrl: 'https://www.figma.com/design/IRWiqQ0jR1jVIY7uOu8YSq/%F0%9F%94%97Design-System--NEW-?node-id=2-46' },
    { cName: 'Tag', cId: 'ui-book/tag', figmaUrl: 'https://www.figma.com/design/IRWiqQ0jR1jVIY7uOu8YSq/%F0%9F%94%97Design-System--NEW-?node-id=63-2022' },
    { cName: 'Typography', cId: 'ui-book/typography', figmaUrl: 'https://www.figma.com/design/IRWiqQ0jR1jVIY7uOu8YSq/%F0%9F%94%97Design-System--NEW-?node-id=2-44' },
  ]

  @action
  setupScrollObserver() {
    // Use a longer delay to ensure all child components are rendered
    setTimeout(() => {
      const sections = this.uiBookComponents.map(comp => document.getElementById(comp.cName)).filter(Boolean);

      if (sections.length === 0) {
        // Retry after a longer delay if sections aren't found
        setTimeout(() => this.setupScrollObserver(), 500);
        return;
      }

      const observer = new IntersectionObserver(
        (entries) => {
          // Find the section that's most visible
          let mostVisible = null;
          let maxRatio = 0;

          entries.forEach((entry) => {
            if (entry.isIntersecting && entry.intersectionRatio > maxRatio) {
              maxRatio = entry.intersectionRatio;
              mostVisible = entry.target.id;
            }
          });

          if (mostVisible) {
            this.activeSection = mostVisible;
          }
        },
        {
          root: null,
          rootMargin: '-10% 0px -60% 0px', // Trigger when section is 10% from top
          threshold: [0, 0.1, 0.25, 0.5, 0.75, 1.0] // Multiple thresholds for better detection
        }
      );

      sections.forEach(section => {
        observer.observe(section);
      });

      // Cleanup observer when component is destroyed
      this.observer = observer;
    }, 200);
  }

  willDestroy() {
    super.willDestroy();
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  @action
  isActive(anchor) {
    return this.activeSection === anchor;
  }

  @action
  scrollToSection(event) {
    event.preventDefault();
    const targetId = event.target.getAttribute('href').substring(1);
    const targetElement = document.getElementById(targetId);

    if (targetElement) {
      const headerHeight = 80;
      const offset = headerHeight + 36; // Add extra 20px for better spacing

      const targetPosition = targetElement.offsetTop - offset;

      window.scrollTo({
        top: targetPosition,
        behavior: 'instant'
      });
    }
  }
}